function addCommas(input) {
  return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function removeCommas(input) {
  return input.replace(/,/g, "");
}

function addMonths(dateString, step) {
  const [year, month, day] = dateString.split("/");
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

  date.setMonth(date.getMonth() + step);

  let newMonth = date.getMonth() + 1;
  let newYear = date.getFullYear();

  if (newMonth > 12) {
    newYear += Math.floor((newMonth - 1) / 12);
    newMonth = ((newMonth - 1) % 12) + 1;
  }

  newMonth = newMonth.toString().padStart(2, "0");
  const newDay = date.getDate().toString().padStart(2, "0");

  return `${newYear}/${newMonth}/${newDay}`;
}

function validateNationalCode(input) {
  return /^\d{10}$/.test(input);
}

function validateMobile(input) {
  return /^09\d{9}$/.test(input);
}

const UtilsFunctions = {
  addCommas,
  removeCommas,
  addMonths,
  validateNationalCode,
  validateMobile,
};

export default UtilsFunctions;
